
import React, { memo } from 'react';
import SocialProfilesContent from './SocialProfilesContent';
import Form from '../../Form';



















function SocialProfiles(
{
  socialProfiles,
  profileImage,
  onSave,
  title,
  className,
  defaultImage,
  imagePlaceholder,
  allowedSocialTypes,
  modalTitle,
  modalDescription,
  buttonTitle,
  onSelectImage,
  disabled
})
{
  return (
    <Form.TitledFormBlock
      title={title}
      className={className}
      itemImage={profileImage}
      defaultImage={defaultImage}
      imagePlaceholder={imagePlaceholder}>

      <SocialProfilesContent
        socialProfiles={socialProfiles}
        onSave={onSave}
        modalTitle={modalTitle}
        modalDescription={modalDescription}
        buttonTitle={buttonTitle}
        allowedSocialTypes={allowedSocialTypes}
        onSelectImage={onSelectImage}
        disabled={disabled} />

    </Form.TitledFormBlock>);

}

export default memo(SocialProfiles);